const QuickTiles = () => {
  return (
    <section className="px-6 py-16 bg-gray-50 md:px-12">
      <div className="mx-auto text-center max-w-7xl">
        <h2 className="mb-12 text-3xl font-bold text-gray-800 md:text-4xl">Why Choose Blessed Montessori?</h2>
        <div className="grid gap-6 text-left md:grid-cols-4">
          {[
            {
              icon: "🎓",
              title: "Montessori Method",
              desc: "Our curriculum is rooted in the internationally renowned Montessori approach.",
            },
            {
              icon: "🌐",
              title: "Global Exposure",
              desc: "Students participate in global exchange programs and digital learning.",
            },
            {
              icon: "🤝",
              title: "Family Partnership",
              desc: "We work closely with families to guide each child's learning journey.",
            },
            {
              icon: "🧠",
              title: "Creative Innovation",
              desc: "STEM, robotics, and problem-solving are at the heart of what we do.",
            },
          ].map((tile, index) => (
            <div key={index} className="p-6 transition bg-white rounded-lg shadow-md hover:shadow-xl">
              <div className="mb-4 text-3xl">{tile.icon}</div>
              <h3 className="mb-2 text-xl font-semibold">{tile.title}</h3>
              <p className="text-gray-600">{tile.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default QuickTiles;
